/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceInfoResponse
 */
export interface DeviceInfoResponse {
    /**
     * 
     * @type {number}
     * @memberof DeviceInfoResponse
     */
    deviceInfoId: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfoResponse
     */
    deviceType: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfoResponse
     */
    deviceBrand: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfoResponse
     */
    devicePlatform: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceInfoResponse
     */
    deviceOsVersion: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceInfoResponse
     */
    deviceOsApi: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfoResponse
     */
    webUa: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfoResponse
     */
    cpuAbi: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceInfoResponse
     */
    resolutionWidth: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceInfoResponse
     */
    resolutionHeight: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceInfoResponse
     */
    dpi: number;
}

/**
 * Check if a given object implements the DeviceInfoResponse interface.
 */
export function instanceOfDeviceInfoResponse(value: object): value is DeviceInfoResponse {
    if (!('deviceInfoId' in value) || value['deviceInfoId'] === undefined) return false;
    if (!('deviceType' in value) || value['deviceType'] === undefined) return false;
    if (!('deviceBrand' in value) || value['deviceBrand'] === undefined) return false;
    if (!('devicePlatform' in value) || value['devicePlatform'] === undefined) return false;
    if (!('deviceOsVersion' in value) || value['deviceOsVersion'] === undefined) return false;
    if (!('deviceOsApi' in value) || value['deviceOsApi'] === undefined) return false;
    if (!('webUa' in value) || value['webUa'] === undefined) return false;
    if (!('cpuAbi' in value) || value['cpuAbi'] === undefined) return false;
    if (!('resolutionWidth' in value) || value['resolutionWidth'] === undefined) return false;
    if (!('resolutionHeight' in value) || value['resolutionHeight'] === undefined) return false;
    if (!('dpi' in value) || value['dpi'] === undefined) return false;
    return true;
}

export function DeviceInfoResponseFromJSON(json: any): DeviceInfoResponse {
    return DeviceInfoResponseFromJSONTyped(json, false);
}

export function DeviceInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'deviceInfoId': json['device_info_id'],
        'deviceType': json['device_type'],
        'deviceBrand': json['device_brand'],
        'devicePlatform': json['device_platform'],
        'deviceOsVersion': json['device_os_version'],
        'deviceOsApi': json['device_os_api'],
        'webUa': json['web_ua'],
        'cpuAbi': json['cpu_abi'],
        'resolutionWidth': json['resolution_width'],
        'resolutionHeight': json['resolution_height'],
        'dpi': json['dpi'],
    };
}

export function DeviceInfoResponseToJSON(json: any): DeviceInfoResponse {
    return DeviceInfoResponseToJSONTyped(json, false);
}

export function DeviceInfoResponseToJSONTyped(value?: DeviceInfoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'device_info_id': value['deviceInfoId'],
        'device_type': value['deviceType'],
        'device_brand': value['deviceBrand'],
        'device_platform': value['devicePlatform'],
        'device_os_version': value['deviceOsVersion'],
        'device_os_api': value['deviceOsApi'],
        'web_ua': value['webUa'],
        'cpu_abi': value['cpuAbi'],
        'resolution_width': value['resolutionWidth'],
        'resolution_height': value['resolutionHeight'],
        'dpi': value['dpi'],
    };
}

